import { render, staticRenderFns } from "./LocalForageView.vue?vue&type=template&id=6c23e1fe&scoped=true"
import script from "./LocalForageView.vue?vue&type=script&lang=js"
export * from "./LocalForageView.vue?vue&type=script&lang=js"
import style0 from "./LocalForageView.vue?vue&type=style&index=0&id=6c23e1fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23e1fe",
  null
  
)

export default component.exports